import React from 'react'

const AssociationDetails = ({currentAssociation}) => {
  return (
    <>
        {/* Profile image */}
        <div className="card">
            <div className="card-body p-3">
                <div className="text-center">
                <div
                    className="profile-user position-relative d-inline-block mx-auto mb-2"
                >
                    <img
                        src="/assets/images/svg/crypto-icons/eth.svg"
                        className="rounded-circle avatar-lg img-thumbnail user-profile-image"
                        alt="user-profile-image"
                    />
                </div>
                <h5 className="fs-16 mb-1">{currentAssociation?.name}</h5>
                <p className="text-muted mb-0">{currentAssociation?.reg_number}</p>
                </div>
            </div>
        </div>

        {/* Basic Info */}
        <div className="card">
            <div className="card-body">
                <h5 className="card-title mb-3">Basic Info</h5>
                <div className="table-responsive">
                    <table className="table table-borderless mb-0">
                        <tbody>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Name :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.name}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Reg Number :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.reg_number}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">E-mail :</th>
                                <td className="text-muted py-2">{currentAssociation?.email}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Phone :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.phone}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Address :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.address}
                                </td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Est. :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.year_established}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Membership Mode :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.membership_mode}</td>
                            </tr>
                            {currentAssociation?.membership_mode == 'paid' && <tr>
                                <th className="ps-0 py-2" scope="row">Membership Fee :</th>
                                <td className="text-muted py-2 text-capitalize">₦{Number(currentAssociation?.membership_fee).toLocaleString()}</td>
                            </tr>}
                            <tr>
                                <th className="ps-0 py-2" scope="row">Membership Status :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.membership_status}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Bio :</th>
                                <td className="text-muted py-2 text-capitalize">{currentAssociation?.description}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        {/* Children Details */}
        {/* <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center mb-4">
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-0">Children</h5>
                    </div>
                </div>
                <div>
                    <div className="d-flex align-items-center py-2">
                        <div className="avatar-xs flex-shrink-0 me-3">
                            <img src="/assets/images/users/avatar-3.jpg" alt="" className="img-fluid rounded-circle" />
                        </div>
                        <div className="flex-grow-1">
                            <div>
                                <h5 className="fs-14 mb-1">Esther James</h5>
                                <p className="fs-12 text-muted mb-0"><b><i className='bx bx-calendar'></i></b>&nbsp; 05-06-1995</p>
                            </div>
                        </div>
                        <div className="flex-shrink-0 ms-2">
                            <button type="button" className="btn btn-sm btn-outline-success"><i className="ri-user-add-line align-middle"></i></button>
                        </div>
                    </div>
                    <div className="d-flex align-items-center py-2">
                        <div className="avatar-xs flex-shrink-0 me-3">
                            <img src="/assets/images/users/avatar-4.jpg" alt="" className="img-fluid rounded-circle" />
                        </div>
                        <div className="flex-grow-1">
                            <div>
                                <h5 className="fs-14 mb-1">Jacqueline Steve</h5>
                                <p className="fs-12 text-muted mb-0"><b><i className='bx bx-calendar'></i></b>&nbsp; 05-06-1995</p>
                            </div>
                        </div>
                        <div className="flex-shrink-0 ms-2">
                            <button type="button" className="btn btn-sm btn-outline-success"><i className="ri-user-add-line align-middle"></i></button>
                        </div>
                    </div>
                    <div className="d-flex align-items-center py-2">
                        <div className="avatar-xs flex-shrink-0 me-3">
                            <img src="/assets/images/users/avatar-5.jpg" alt="" className="img-fluid rounded-circle" />
                        </div>
                        <div className="flex-grow-1">
                            <div>
                                <h5 className="fs-14 mb-1">George Whalen</h5>
                                <p className="fs-12 text-muted mb-0"><b><i className='bx bx-calendar'></i></b>&nbsp; 05-06-1995</p>
                            </div>
                        </div>
                        <div className="flex-shrink-0 ms-2">
                            <button type="button" className="btn btn-sm btn-outline-success"><i className="ri-user-add-line align-middle"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}
    </>
  )
}

export default AssociationDetails
